import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-terms',
  templateUrl: './show-terms.component.html',
  styleUrls: ['./show-terms.component.scss'],
})
export class ShowTermsComponent implements OnInit {
  // service;
  // constructor() {}

  // async ngOnInit(): Promise<void> {
  //   this.service = '서비스 이용약관 입니다.';
  // }

  service: string;

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.db.doc$('appService/terms').subscribe(({ serviceTerm }) => {
      this.service = serviceTerm;
    });
  }
}
